import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';
import ForumForm from './ForumForm';

const ForumNew = () => {
  const { post, loading } = useApi();
  const navigate = useNavigate();

  const handleSubmit = (body: Record<string, string | string[] | undefined | null>, status: 'DRAFT' | 'OPEN') => {
    post({
      endpoint: 'api/v1/forum_posts',
      body: { ...body, status },
      onSuccess: () => {
        toast.success(status === 'DRAFT' ? '下書きを保存しました' : '投稿しました');
        navigate('/mypage/forum');
      },
      onError: (err) => { toast.error(err?.data?.message || '保存に失敗しました'); },
    });
  };

  return <ForumForm title="募集投稿を作成" loading={ loading } onSubmit={ handleSubmit } />;
};

export default ForumNew;
